import React                     from 'react';
import MainLayout                from '../layout/MainLayout';
import Dashboard                 from '../pages/Dashboard';
import UploadMappingFile         from '../pages/UploadMappingFile';
import MappingFileDownload       from '../pages/MappingFileDownload';
import Parameters                from '../pages/Parameters';
import Events                    from '../pages/Events';
import EditEvent                 from '../pages/Events/EditEvent';
//import SingleEvent             from '../pages/Events/SingleEvent';
import Connections               from '../pages/Connections';
import Settings                  from '../pages/Settings';
import ModBus                    from '../pages/ModBus';
import STHomePage                from '../pages/STHomePage';
import ECUConstantTxMessages     from '../pages/Can/ECUConstantTxMessages';
import ECUConstantTxMessagesNew  from '../pages/Can/ECUConstantTxMessages/addNew';
import ECUIDDefinitions          from '../pages/Can/ECUIDDefinitions';
import ECUIDDefinitionsNew       from '../pages/Can/ECUIDDefinitions/addNew';
import ECURequestPGN             from '../pages/Can/ECURequestPGN';
import ECUReceiveMessages        from '../pages/Can/ECUReceiveMessages';
import ECUReceiveMessageEdit     from '../pages/Can/ECUReceiveMessages/ECUReceiveMessageEdit';
import ECUReceiveMessagesNew   from '../pages/Can/ECUReceiveMessages/addNew';
import ECUTransmitMessages       from '../pages/Can/ECUTransmitMessages';
import ECUTransmitMessagesNew    from '../pages/Can/ECUTransmitMessages/addNew';
import GenerateConfig            from '../pages/GenerateConfig';
import UploadConfigFile          from '../pages/UploadConfigFile';
import MappingParameters         from '../pages/ViewMappings/Parameters';
import MappingConnections        from '../pages/ViewMappings/Connections';
import MappingEvents             from '../pages/ViewMappings/Events';
import MappingEditEvents         from '../pages/ViewMappings/Events/EditMappingEvent';
import HomePage                  from '../pages/ViewMappings/HomePage';
import MappingModbus             from '../pages/ViewMappings/Modbus';
import JsonMappings              from '../pages/ViewMappings/JsonMappings';
import MappingECUConstantTxMessages     from '../pages/Can/ECUConstantTxMessages';
import MappingECUIDDefinitions          from '../pages/Can/ECUIDDefinitions';
import MappingECURequestPGN             from '../pages/Can/ECURequestPGN';
import MappingReceiveMessages           from '../pages/ViewMappings/ECUReceiveMessages';
import MappingTransmitMessages          from '../pages/Can/ECUTransmitMessages';
import MappingECUConstantTxMessagesNew  from '../pages/Can/ECUConstantTxMessages/addNew';
import MappingECUIDDefinitionsNew       from '../pages/Can/ECUIDDefinitions/addNew';
import MappingECUReceiveMessagesNew     from '../pages/Can/ECUReceiveMessages/addNew'
import MappingECUTransmitMessagesNew    from '../pages/Can/ECUTransmitMessages/addNew';
import ProjectsList                     from '../pages/ProjectsList';
import PageNotFound                     from '../pages/PageNotFound';
import AccessDenied                     from '../pages/AccessDenied';
import Feedback                         from '../pages/Feedback';
import { ProtectedRoute }               from './ProtectedRoute';
import MappingECUReceiveMessageEdit from '../pages/ViewMappings/ECUReceiveMessages/MappingECUReceiveMessageEdit';



// import { LoginCallback } from "@okta/okta-react";
// import { RequiredAuth } from './RequiredAuth';

const MainRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    // { path: '/login/callback', element: <LoginCallback /> },
    { path: '/', element: <Dashboard /> },
    { path: '/mapping/upload', element: <UploadMappingFile />},
    { path: '/mapping/download', element: <MappingFileDownload /> },
    { path: '/parameters', element: <Parameters /> },
    { path: '/events', element: <Events /> },
    { path: '/events/edit', element: <EditEvent /> },
    //{ path: '/events/:id/details', element: <SingleEvent /> },
    { path: '/connections', element: <Connections /> },
    { path: '/modbus', element: <ModBus /> },
    { path: '/settings', element: <Settings /> },
    { path: '/st-homepage', element: <STHomePage /> },
    { path: '/can/constant-messages', element: <ECUConstantTxMessages /> },
    { path: '/can/constant-messages/new', element: <ECUConstantTxMessagesNew /> },
    { path: '/can/definitions', element: <ECUIDDefinitions /> },
    { path: '/can/definitions/new', element: <ECUIDDefinitionsNew /> },
    { path: '/can/request-pgn', element: <ECURequestPGN /> },
    { path: '/can/receive-messages', element: <ECUReceiveMessages /> },
    { path: '/can/receive-messages/edit', element: <ECUReceiveMessageEdit /> },
    { path: '/can/receive-messages/new', element: <ECUReceiveMessagesNew /> },
    { path: '/can/transmit-messages', element: <ECUTransmitMessages /> },
    { path: '/can/transmit-messages/new', element: <ECUTransmitMessagesNew /> },
    { path: '/generate-config', element: <GenerateConfig /> },
    { path: '/config/add-project', element: <UploadConfigFile /> },
    { path: '/view/json-mappings', element: <JsonMappings /> },
    { path: '/mapping/parameters', element: <MappingParameters /> },
    { path: '/mapping/connections', element: <MappingConnections /> },
    { path: '/mapping/events', element: <MappingEvents /> },
    { path: '/mapping/modbus', element: <MappingModbus /> },
    { path: '/mapping/homepage', element: <HomePage /> },
    { path: '/mapping/can/constant-messages', element: <MappingECUConstantTxMessages /> },
    { path: '/mapping/can/definitions', element: <MappingECUIDDefinitions /> },
    { path: '/mapping/can/request-pgn', element: <MappingECURequestPGN /> },
    { path: '/mapping/can/receive-messages', element: <MappingReceiveMessages /> },
    { path: '/mapping/can/receive-messages/edit', element: <MappingECUReceiveMessageEdit /> },
    { path: '/mapping/can/transmit-messages', element: <MappingTransmitMessages /> },
    { path: '/mapping/can/constant-messages/new', element: <MappingECUConstantTxMessagesNew /> },
    { path: '/mapping/can/definitions/new', element: <MappingECUIDDefinitionsNew /> },
    { path: '/mapping/can/receive-messages/new', element: <MappingECUReceiveMessagesNew /> },
    { path: '/mapping/can/transmit-messages/new', element: <MappingECUTransmitMessagesNew /> },
    { path: '/mapping/events/edit', element: <MappingEditEvents /> },
    { path: '/config/projects-list', element: <ProjectsList /> },
    { path: '/help', element: <Feedback /> },
    { path: '/access-denied', element: <AccessDenied /> },
    { path: '*', element: <PageNotFound /> },
  ]
  // children: [
  //   // { path: '/login/callback', element: <LoginCallback /> },
  //   { path: '/', element: <ProtectedRoute><Dashboard /></ProtectedRoute> },
  //   { path: '/mapping/upload', element: <ProtectedRoute><UploadMappingFile /></ProtectedRoute>},
  //   { path: '/mapping/download', element: <ProtectedRoute><MappingFileDownload /></ProtectedRoute> },
  //   { path: '/parameters', element: <ProtectedRoute><Parameters /></ProtectedRoute> },
  //   { path: '/events', element: <ProtectedRoute><Events /></ProtectedRoute> },
  //   { path: '/events/edit', element: <ProtectedRoute><EditEvent /></ProtectedRoute> },
  //   //{ path: '/events/:id/details', element: <ProtectedRoute><SingleEvent /></ProtectedRoute> },
  //   { path: '/connections', element: <ProtectedRoute><Connections /></ProtectedRoute> },
  //   { path: '/modbus', element: <ProtectedRoute><ModBus /></ProtectedRoute> },
  //   { path: '/settings', element: <ProtectedRoute><Settings /></ProtectedRoute> },
  //   { path: '/st-homepage', element: <ProtectedRoute><STHomePage /></ProtectedRoute> },
  //   { path: '/can/constant-messages', element:<ProtectedRoute> <ECUConstantTxMessages /></ProtectedRoute> },
  //   { path: '/can/constant-messages/new', element: <ProtectedRoute><ECUConstantTxMessagesNew /></ProtectedRoute> },
  //   { path: '/can/definitions', element: <ProtectedRoute><ECUIDDefinitions /> </ProtectedRoute>},
  //   { path: '/can/definitions/new', element: <ProtectedRoute><ECUIDDefinitionsNew /></ProtectedRoute> },
  //   { path: '/can/request-pgn', element: <ProtectedRoute><ECURequestPGN /> </ProtectedRoute>},
  //   { path: '/can/receive-messages', element: <ProtectedRoute><ECUReceiveMessages /></ProtectedRoute> },
  //   { path: '/can/receive-messages/edit', element: <ProtectedRoute><ECUReceiveMessageEdit /></ProtectedRoute> },
  //   { path: '/can/receive-messages/new', element: <ProtectedRoute><ECUReceiveMessagesNew /></ProtectedRoute> },
  //   { path: '/can/transmit-messages', element: <ProtectedRoute><ECUTransmitMessages /></ProtectedRoute> },
  //   { path: '/can/transmit-messages/new', element: <ProtectedRoute><ECUTransmitMessagesNew /></ProtectedRoute> },
  //   { path: '/generate-config', element: <ProtectedRoute><GenerateConfig /> </ProtectedRoute>},
  //   { path: '/config/add-project', element: <ProtectedRoute><UploadConfigFile /></ProtectedRoute> },
  //   { path: '/view/json-mappings', element: <ProtectedRoute><JsonMappings /></ProtectedRoute> },
  //   { path: '/mapping/parameters', element: <ProtectedRoute><MappingParameters /></ProtectedRoute> },
  //   { path: '/mapping/connections', element: <ProtectedRoute><MappingConnections /></ProtectedRoute> },
  //   { path: '/mapping/events', element: <ProtectedRoute><MappingEvents /></ProtectedRoute> },
  //   { path: '/mapping/modbus', element: <ProtectedRoute><MappingModbus /></ProtectedRoute> },
  //   { path: '/mapping/homepage', element: <ProtectedRoute><HomePage /></ProtectedRoute> },
  //   { path: '/mapping/can/constant-messages', element:<ProtectedRoute> <MappingECUConstantTxMessages /></ProtectedRoute> },
  //   { path: '/mapping/can/definitions', element: <ProtectedRoute><MappingECUIDDefinitions /> </ProtectedRoute>},
  //   { path: '/mapping/can/request-pgn', element: <ProtectedRoute><MappingECURequestPGN /> </ProtectedRoute>},
  //   { path: '/mapping/can/receive-messages', element: <ProtectedRoute><MappingReceiveMessages /></ProtectedRoute> },
  //   { path: '/mapping/can/receive-messages/edit', element: <ProtectedRoute><MappingECUReceiveMessageEdit /></ProtectedRoute> },
  //   { path: '/mapping/can/transmit-messages', element: <ProtectedRoute><MappingTransmitMessages /></ProtectedRoute> },
  //   { path: '/mapping/can/constant-messages/new', element: <ProtectedRoute><MappingECUConstantTxMessagesNew /></ProtectedRoute> },
  //   { path: '/mapping/can/definitions/new', element: <ProtectedRoute><MappingECUIDDefinitionsNew /></ProtectedRoute> },
  //   { path: '/mapping/can/receive-messages/new', element: <ProtectedRoute><MappingECUReceiveMessagesNew /></ProtectedRoute> },
  //   { path: '/mapping/can/transmit-messages/new', element: <ProtectedRoute><MappingECUTransmitMessagesNew /></ProtectedRoute> },
  //   { path: '/mapping/events/edit', element: <ProtectedRoute><MappingEditEvents /></ProtectedRoute> },
  //   { path: '/config/projects-list', element: <ProtectedRoute><ProjectsList /></ProtectedRoute> },
  //   { path: '/help', element: <ProtectedRoute><Feedback /></ProtectedRoute> },
  //   { path: '/access-denied', element: <ProtectedRoute><AccessDenied /></ProtectedRoute> },
  //   { path: '*', element: <ProtectedRoute><PageNotFound /></ProtectedRoute> },
  // ]

};

export default MainRoutes;
